'use client';

import { useBreakpointValue } from '@chakra-ui/react';
import { usePathname } from 'next/navigation';

import FooterMobile from './footerMobile';
import FooterPC from './footerPC';

export function FooterWrapper() {
  const pathname = usePathname();
  const showNavbar = pathname.split('/').some((path) => ['home', 'marketplace'].includes(path))

  // Logic for app download - detect platform and redirect to appropriate store
  const userAgent = navigator.userAgent;

  // Desktop - show both options or default to iOS App Store
  const isMobile =
    /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent,
    );

  return <>{showNavbar ? isMobile ? <FooterMobile /> : <FooterPC /> : null}</>;
}
